/**
 * Utilitários de tema compartilhados entre initTheme (main), ThemeLoader e useTheme.
 */

export type ThemeMode = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

export const THEME_STORAGE_KEY = 'synap-theme'

export const getSystemTheme = (): ResolvedTheme =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'

/**
 * Cor da barra do navegador por tema = `--color-chrome` (cabeçalho da app) em `src/index.css`.
 * `public/theme-boot.js` repete estes valores para o 1º paint (teste garante que batem).
 */
export const THEME_CHROME_COLORS: Record<ResolvedTheme, string> = {
  light: '#ffffff',
  dark: '#081f26',
}

/** Toda meta theme-color segue o tema da app (inclusive as com `media`, que seguiriam o SO). */
export const syncThemeColorMeta = (resolved: ResolvedTheme) => {
  if (typeof document === 'undefined') return
  const color = THEME_CHROME_COLORS[resolved]
  document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]').forEach((meta) => {
    meta.content = color
  })
}

export const applyTheme = (resolved: ResolvedTheme) => {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('data-theme', resolved)
  syncThemeColorMeta(resolved)
}

export const resolveTheme = (mode: ThemeMode): ResolvedTheme =>
  mode === 'system' ? getSystemTheme() : mode
